import { BASE_MODELS } from "./baseModels";
import { MODELS_BY_COUNTRY } from "./modelsByCountry";
import { configuracionDePais } from "../../utils/configuracionDePais";

export const getModels = (country) => {
  const rules = configuracionDePais(MODELS_BY_COUNTRY, country?.code, "modelos de la base local");

  const { hide = [], include = [] } = rules;

  const filtered = BASE_MODELS.filter((model) => !hide.includes(model.key));
  const extended = [...filtered, ...include];

  return extended;
};
